/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState } from 'react';
import BackgroundFinishedCourse from 'assets/images/finished_course.png';
import RadioButtonSelect from 'components/atoms/radio_button_select';
import { pdf, Document, Page, View, Text, Image, StyleSheet, Line, Svg } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import { ProfileState } from 'store/modules/profile_store/types';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import Certificado from 'assets/images/certificado.png';
import { openSupportChat } from 'services/support_chat';
import { Container } from './styles';

const FinishedCourse = () => {
  const [statusCourse, setStatusCourse] = useState<boolean>(true);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const toggleConcluded = (id: string, updateAll = true) => {
    setStatusCourse(updateAll);
  };

  const styles = StyleSheet.create({
    page: {
      width: '100%',
      height: '60%',
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1,
    },
    text: {
      position: 'absolute',
      left: '0px',
      right: '0px',
      marginHorizontal: 'auto',
      textAlign: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '20px',
    },
    textTitle: {
      position: 'absolute',
      left: '0px',
      right: '0px',
      marginHorizontal: 'auto',
      textAlign: 'center',
      justifyContent: 'center',
      color: 'white',
      fontSize: '22px',
    },
    text3: {
      position: 'absolute',
      left: '60px',
      right: '0px',
      marginHorizontal: 'auto',
      textAlign: 'left',
      color: 'white',
      fontSize: '14px',
    },
  });

  const generatePDFDocument = async () => {
    const blob = await pdf(
      <Document style={styles.page}>
        <Page
          dpi={75}
          size={{ width: 18.9 * 37.7952755906, height: 10 * 37.7952755906 }}
          wrap={false}
        >
          <View>
            <Image src={Certificado} />
          </View>
          <Text style={{ top: '90px', ...styles.textTitle }}>Este certificado é concedido a</Text>
          <Text style={{ top: '125px', ...styles.text }}>{profile?.name}</Text>
          <Svg height="10" width="495">
            <Line x1="0" y1="5" x2="280" y2="5" strokeWidth={2} stroke="rgb(255,255,255)" />
          </Svg>
          <Text style={{ top: '170px', ...styles.textTitle }}>
            pela conclusão bem-sucedida do treinamento Licitação do Zero.
          </Text>
          <Text style={{ top: '210px', ...styles.text3 }}>Objetivos alcançados:</Text>
          <Text style={{ top: '240px', ...styles.text3 }}>
            - Compreensão do processo de venda ao governo.
          </Text>
          <Text style={{ top: '270px', ...styles.text3 }}>
            - Desenvolvimento de uma metodologia segura para participar de vendas ao governo.
          </Text>
          <Text style={{ top: '300px', ...styles.text3 }}>
            - Capacidade de iniciar no mercado de vendas ao governo com direcionamento adequado.
          </Text>
          <Text style={{ top: '330px', ...styles.text3 }}>
            - Identificação prática do potencial de vender para o governo.
          </Text>
          <Text style={{ top: '360px', ...styles.text3 }}>
            Parabenizamos pela conclusão do treinamento em Vendas ao Governo
          </Text>
          <Text style={{ top: '380px', ...styles.text3 }}>desejamos sucesso em sua jornada.</Text>
        </Page>
      </Document>,
    ).toBlob();
    saveAs(blob, profile?.name);
  };
  return (
    <Container>
      <div className="card mt-4 p-4">
        <img src={BackgroundFinishedCourse} alt="Finalizou curso" />
        <div className="row mt-5">
          <div className="col-md-6">
            <p>
              Agora você tem todo o conhecimento necessário para iniciar sua jornada no mercado de
              compras públicas.
            </p>
            <p>
              Caso tenha dúvidas, fale com nossa
              <button
                type="button"
                className="btn btn-link pl-1"
                onClick={() => {
                  openSupportChat();
                }}
              >
                equipe de atendimento
              </button>
            </p>

            <button
              type="button"
              className="btn btn-primary mr-1"
              onClick={() => generatePDFDocument()}
            >
              Baixar agora seu certificado
            </button>

            <div className="mt-4">
              <p>Reveja o curso sempre que precisar</p>
            </div>
          </div>
          <div className="col-md-6">
            <h5 className="font-weight-bold">Vamos para o próximo passo? </h5>

            <div className="card p-3 mt-3 bg-ferramentas">
              <a href="/curso" className="btn btn-course mt-2 text-left text-white py-0">
                1. Ver conteúdo do curso
                <RadioButtonSelect
                  isChecked={statusCourse}
                  text=""
                  toggleSelectContracts={toggleConcluded}
                />
              </a>
              <a href="/banco_de_dados" className="btn btn-course mt-2 text-left text-white">
                2. Encontrar oportunidades
              </a>
              <a href="/mercado" className="btn btn-course mt-2 text-left text-white">
                3. Analisar o mercado
              </a>
              <a
                href="/minhas_licitacoes/management"
                className="btn btn-course mt-2 text-left text-white"
              >
                4. Gerenciar licitações
              </a>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default FinishedCourse;
